import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class WoodenCabinet extends DestroyableObstacle {
	static key = "WoodenCabinet";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.WOOD_DEBRIS;
	}

	static deserialize(data: any): WoodenCabinet {
		const c = new WoodenCabinet(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
